const articlesApi = {
  // Fetch paginated articles with full metadata (tags, topics, technologies)

  getEntireArticles: async () => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles`
      );
      return response.json();
    } catch (error) {
      console.error("Error fetching entire articles:", error);
      return [];
    }
  },

  searchArticles: async (query) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles/search?q=${query}`
      );
      return response.json();
    } catch (error) {
      console.error("Error searching articles:", error);
      return {};
    }
  },

  getPaginatedArticles: async (page = 1, pageSize = 5) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles?pagination[page]=${page}&pagination[pageSize]=${pageSize}&sort[0]=publishedAt:desc&populate[articleImage][fields][0]=url&populate[authorImage][fields][0]=url&populate[technology][fields][0]=name&populate[technology][fields][1]=slug&populate[topic][fields][0]=name&populate[topic][fields][1]=slug&populate[tags][fields][0]=name&populate[tags][fields][1]=slug`
      );

      return response.json();
    } catch (error) {
      console.error("Error fetching articles:", error);
      return [];
    }
  },

  getPaginatedArticlesByTechnology: async (
    technologySlug,
    page = 1,
    pageSize = 3
  ) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles?filters[technology][slug][$eq]=${technologySlug}&pagination[page]=${page}&pagination[pageSize]=${pageSize}&sort[0]=publishedAt:desc&populate[articleImage][fields][0]=url&populate[authorImage][fields][0]=url&populate[technology][fields][0]=name&populate[technology][fields][1]=slug&populate[topic][fields][0]=name&populate[topic][fields][1]=slug&populate[tags][fields][0]=name&populate[tags][fields][1]=slug`
      );

      return response.json();
    } catch (error) {
      console.error("Error fetching articles:", error);
      return [];
    }
  },

  // Fetch an article by slug with full metadata
  getArticleBySlug: async (slug) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles?filters[slug][$eq]=${slug}&populate[technology][fields][0]=name&populate[technology][fields][1]=slug&populate[topic][fields][0]=name&populate[topic][fields][1]=slug&populate[tags][fields][0]=name&populate[tags][fields][1]=slug`
      );
      return response.json();
    } catch (error) {
      console.error("Error fetching article by slug:", error);
      return [];
    }
  },

  getArticlesByTag: async (tagSlug) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles?filters[tags][slug][$eq]=${tagSlug}&populate[articleImage][fields][0]=url&populate[authorImage][fields][0]=url&populate[technology][fields][0]=name&populate[technology][fields][1]=slug&populate[topic][fields][0]=name&populate[topic][fields][1]=slug&populate[tags][fields][0]=name&populate[tags][fields][1]=slug`
      );
      return response.json();
    } catch (error) {
      console.error("Error fetching articles by tag:", error);
      return [];
    }
  },

  getArticlesByTopic: async (topicSlug) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles?filters[topic][slug][$eq]=${topicSlug}&populate[articleImage][fields][0]=url&populate[authorImage][fields][0]=url&populate[technology][fields][0]=name&populate[technology][fields][1]=slug&populate[topic][fields][0]=name&populate[topic][fields][1]=slug&populate[tags][fields][0]=name&populate[tags][fields][1]=slug`
      );
      return response.json();
    } catch (error) {
      console.error("Error fetching articles by topic:", error);
      return [];
    }
  },

  // Fetch distinct topics, tags, and technologies
  getArticleMetadata: async () => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BE_HOST}/articles?fields[0]=topics&fields[1]=tags&fields[2]=technology&populate=*`
      );
      return response.json();
    } catch (error) {
      console.error("Error fetching article metadata:", error);
      return [];
    }
  },
};

export default articlesApi;
